import { defineStore } from "pinia"

export type KeycloakConfig = {
  keycloakUrl: string
  keycloakClientId: string
  keycloakRealm: string
}

export const useKeycloakConfigStore = defineStore("keycloakConfig", () => {
  let config: Promise<KeycloakConfig> | null = null
  function load(): Promise<KeycloakConfig> {
    if (config === null) {
      config = fetch("/.well-known/config.json")
        .then((r) => r.json())
        .catch((e) => {
          console.error(e)
          return { url: "" }
        })
      return config
    } else {
      return config
    }
  }
  return {
    load,
  }
})
